import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';

export const PersianKeyboardModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div className="modal-content" style={{
        backgroundColor: 'white',
        borderRadius: '15px',
        padding: '30px',
        maxWidth: '500px',
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
        position: 'relative',
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '15px',
            right: '20px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#666',
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
        
        <div style={{ marginBottom: '20px' }}>
          <FontAwesomeIcon 
            icon={faExclamationTriangle} 
            style={{ 
              fontSize: '50px', 
              color: '#ff6b6b',
              marginBottom: '15px'
            }} 
          />
        </div>
        
        <h3 style={{ 
          color: '#333', 
          marginBottom: '15px',
          fontSize: '20px',
          fontWeight: 'bold'
        }}>
          تغییر کیبورد
        </h3>
        
        <p style={{ 
          color: '#666', 
          lineHeight: '1.6',
          fontSize: '16px',
          marginBottom: '20px'
        }}>
          لطفاً کیبورد خود را به فارسی تغییر دهید تا بتوانید به درستی تایپ کنید.
        </p>
        
        <div style={{ 
          backgroundColor: '#f8f9fa', 
          padding: '15px', 
          borderRadius: '10px',
          border: '1px solid #e9ecef',
          marginBottom: '20px'
        }}>
          <p style={{ 
            margin: 0, 
            color: '#495057',
            fontSize: '14px'
          }}>
            <strong>راهنمای تغییر کیبورد:</strong><br />
            • در ویندوز: Alt + Shift<br />
            • در مک: Cmd + Space<br />
            • در موبایل: روی آیکون کیبورد ضربه بزنید
          </p>
        </div>
        
        <button
          onClick={onClose}
          style={{
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            padding: '12px 30px',
            borderRadius: '8px',
            fontSize: '16px',
            cursor: 'pointer',
            fontWeight: '500',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
        >
          متوجه شدم
        </button>
      </div>
    </div>
  );
};

